/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientArchiveSettings } from '../../models/patient-archive-settings';

export interface PatientArchiveGet$Params {
}

export function patientArchiveGet(http: HttpClient, rootUrl: string, params?: PatientArchiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientArchiveSettings>> {
  const rb = new RequestBuilder(rootUrl, patientArchiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientArchiveSettings>;
    })
  );
}

patientArchiveGet.PATH = '/api/PatientArchive/patientarchive/getsettings';
